module.exports = __webpack_public_path__ + "static/img/DZ.4cec2ca0.png";